import { UserPageDataRoleItem } from '@maxpreps/apiserviceclients/apiModels';
import { ROLE } from '@maxpreps/shared/constants/authentication';
import { hasPermission } from '@maxpreps/shared/functions/utils/userUtils';

const userCanEnterScores = (
  userRoles: UserPageDataRoleItem[],
  teamId: string,
  allSeasonId: string,
  rolesWhoCanEnterScores: string[],
  reasonWhyCannotEnterScores
) => {
  const rolesWhoCanEnter = rolesWhoCanEnterScores || [];

  const isStandardAdmin = hasPermission(
    [{ roleId: ROLE.standardAdmin }],
    userRoles
  );

  const isHeadCoach = hasPermission(
    [
      {
        roleId: ROLE.athleticDirector,
        accessId1: teamId
      },
      {
        roleId: ROLE.teamAdministrator,
        accessId1: teamId,
        accessId2: allSeasonId
      }
    ],
    userRoles
  );

  // if (appEnv !== 'production') {
  // console.log("Can't enter score because", reasonWhyCannotEnterScores);
  // }

  return (
    (isStandardAdmin && rolesWhoCanEnter.indexOf('StandardAdminUser') > -1) ||
    (isHeadCoach && rolesWhoCanEnter.indexOf('HeadCoach') > -1) ||
    rolesWhoCanEnter.indexOf('Any') > -1
  );
};

export default userCanEnterScores;
